/* eslint-disable import/order */
import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import type AppType from '@jira/spa-apps__admin-pages-system-announcement-banner/src/AppType.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsSystemUiAnnouncementBannerRoute } from '@jira/router-routes__admin-pages-system-routes/src/globalSettingsSystemUiAnnouncementBannerRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyAnnouncementBanner = lazyForPaint<typeof AppType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-system-announcement-banner", jiraSpaEntry: "async-admin-pages-system-announcement-banner" */ '@jira/spa-apps__admin-pages-system-announcement-banner/src/AppType.tsx'
		),
	),
);

const AnnouncementBanner = () => (
	<LazyPage
		Page={LazyAnnouncementBanner}
		pageId="admin-pages-system-announcement-banner"
		shouldShowSpinner
	/>
);

export const globalSettingsSystemUiAnnouncementBannerRouteEntry: Route = createEntry(
	globalSettingsSystemUiAnnouncementBannerRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.system.ui.announcement-banner',
		// eslint-disable-next-line no-restricted-syntax
		component: AnnouncementBanner,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyAnnouncementBanner],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
